import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Button } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';
import moment from 'moment';

import { batchResendOrders } from '../../actions/index';
import ResendOrdersDatePickers from './ResendOrdersDatePickers';
import ResendOrdersResultsModal from './ResendOrdersResultsModal';

class ResendOrdersScreen extends Component {
    constructor() {
        super();

        this.state = {
            datePicker: {
                startFrom: moment().format('YYYY-MM-DDTHH:mm'),
                endTo: ''
            },
            isOpen: false
        }
    }

    componentDidUpdate(prevProps) {

        if (prevProps.resendOrders !== this.props.resendOrders) {

            this.toggleResultsModal();
        }
    }

    toggleResultsModal = () => {

        this.setState({
            ...this.state,
            isOpen: !this.state.isOpen
        });
    }

    renderHeading = () => {
        const { screenHeading } = styles;

        return (
            <div style={screenHeading}>
                <MaterialIcon icon='autorenew' color='#0288d1' size={22} />&nbsp;
                {i18n.t('screens:systemControlContainer.batchResendOrders')}
            </div>
        );
    }

    setDate = ({ target }) => {

        this.setState({
            datePicker: {
                ...this.state.datePicker,
                [target.name]: target.value
            }
        });
    }

    convertToParams(state) {
        let params = `?`;

        for (const [key, value] of Object.entries(state)) {

            if (value) {
                const parsedValue = `${moment(value).format('DD-MM-YYYY HH:mm')}`;

                params += `${key}=${parsedValue}&`;
            }
        }

        return params;
    }

    render() {

        const { containerStyle, contentContainerStyles, saveBtnStyles, wargningStyles } = styles;

        return (
            <Container fluid style={containerStyle}>
                <Row>{this.renderHeading()}</Row>
                <div style={contentContainerStyles}>
                    <ResendOrdersDatePickers state={this.state.datePicker} setDate={this.setDate} />
                    <Button
                        color='primary'
                        style={saveBtnStyles}
                        onClick={() => this.props.batchResendOrders(this.convertToParams(this.state.datePicker))}>
                        {i18n.t('screens:systemControlContainer.resendOrder')}
                    </Button>
                </div>
                <p style={wargningStyles}>*{i18n.t('screens:systemControlContainer.warningMsg')}</p>
                <p style={wargningStyles}>**{i18n.t('screens:systemControlContainer.warningMsgTwo')}</p>
                {
                    this.state.isOpen &&
                    <ResendOrdersResultsModal
                        isOpen={this.state.isOpen}
                        toggle={this.toggleResultsModal}
                        {...this.props} />
                }
            </Container>
        );
    }
}

const mapStateToProps = state => {

    return {
        resendOrders: state.resendOrders
    }
};

export default connect(mapStateToProps, { batchResendOrders })(ResendOrdersScreen);

let styles = {
    containerStyle: {
        marginLeft: 0,
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #0288d1',
        padding: 10
    },
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        marginLeft: 15,
        paddingLeft: 0,
        color: '#0288d1',
        width: 299
    },
    contentContainerStyles: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    saveBtnStyles: {
        display: 'flex',
        alignSelf: 'flex-end',
        alignItems: 'center',
        marginBottom: 10
    },
    wargningStyles: {
        fontSize: 14,
        marginBottom: 0
    }
};


// WEBPACK FOOTER //
// ./src/components/systemControl/ResendOrdersScreen.js